import { useEffect, useState } from "react";
import PricingNavContentPage2 from "./PricingNavContentPage2";
import PricingNavContentPageCompare from "./PricingNavContentPageCompare";
import "../../../../../src/index.css";
import GlowButton from "../../GlowButton";


function PricingNavContentPage1(props) {
  const [btnValue, setBtnValue] = useState("base");
  const [compare, setCompareBtn] = useState(false);
  const [selectedCard, setSelectedCard] = useState();
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isMouseOverForBase, setIsMouseOverForBase] = useState(false);
  const [isMouseOverForPremium, setIsMouseOverForPremium] = useState(false);
  const [isMouseOverForPremiumPlus, setIsMouseOverForPremiumPlus] = useState(false);
  const [isMouseOverForUltimate, setIsMouseOverForUltimate] = useState(false);

  useEffect(() => {
    if (props.defaultCompare) {
      setCompareBtn(false);
    }
  }, [props.defaultCompare]);

  // for Card contents
  const plans = [
    {
      name: "base",
      price: "$30",
      period: "/ month",
      desc: "get the essentials",
      color: "bg-[#A335B7]",
      features: [
        "free 30 day trial",
        "geo online presence (1)",
        "digital menus or catalogs (1)",
        "unlimited chat ordering and chat",
        "free ai ordering and support (1k msgs)",
        "free kitchen or back office display",
        "free pos/in app payments & wallet (low fee)",
      ],
    },
    {
      name: "premium",
      price: "$150",
      period: "/ month",
      desc: "everything in base just more…",
      color: "bg-[#6E9236]",
      features: [
        "free 30 day trial",
        "geo online presence (3)",
        "digital menus or catalogs (10)",
        "free ai ordering and support (40k msgs)",
        "team members (20)",
      ],
    },
    {
      name: "premium plus",
      price: "$230",
      period: "/ month",
      desc: "everything in premium just way more…",
      color: "bg-[#F8B042]",
      features: [
        "free 30 day trial",
        "geo online presence (6)",
        "digital menus or catalogs (20)",
        "free ai ordering and support (100k msgs)",
        "team members (60)",
      ],
    },
    {
      name: "ultimate",
      price: "$400",
      period: "/ month",
      desc: "everything you need…",
      color: "bg-[#3CAA8C]",
      features: [
        "free 30 day trial",
        "geo online presence (10)",
        "digital menus or catalogs (20)",
        "free ai ordering and support (200k msgs)",
        "team members (150)",
      ],
    },
  ];

  function clickCard(index) {
    setSelectedCard(index);
    if (index === 0) setBtnValue("base");
    else if (index === 1) setBtnValue("premium");
    else if (index === 2) setBtnValue("premiumplus");
    else if (index === 3) setBtnValue("ultimate");
  }

  // hover handlers use numeric index
  function handleMouseEnter(index) {
    setHoveredCard(index);
  }
  function handleMouseLeave() {
    setHoveredCard(null);
  }

  return (
    <>
      {props.defaultCompare}
      <div>
        {/* for 4 cards */}
        <section className="w-full bg-white py-12 px-2 sm:px-[30px] md:px-[43px] lg-xl:px-[45px] xl-2xl:px-[53px] mt-[-2rem] sm:mt-[-12rem] ">
            {/* <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-2 xl-2xl:grid-cols-4  gap-5 sm:gap-6 px-4 sm:px-0"> */}
            <div
              className="
    max-w-screen-2xl mx-auto
    flex flex-nowrap gap-4
   overflow-x-auto scrollbar-hidden
    px-4
    md:grid md:grid-cols-2
    xl-2xl:grid-cols-4
    md:overflow-visible 
  "
            >

              {plans.map((plan, index) => {
                const isActive = selectedCard === index;
                const isHover = hoveredCard === index;

                return (
                  <div
                    key={index}
                    // className={`
                    //   group rounded-2xl shadow-md border border-gray-100 flex flex-col justify-between 
                    //   transform transition-all duration-300 ease-in-out

                    //   ${isActive
                    //     ? "scale-105 bg-gradient-to-r from-[#3C0B45] to-[#0F2358] text-white"
                    //     : "hover:scale-105 bg-white text-black hover:bg-gradient-to-r hover:from-[#3C0B45] hover:to-[#0F2358] hover:text-white"
                    //   }
                    // `}

                    className={`
  min-w-[280px] sm:min-w-[270px] 
  xl-2xl:min-w-[330px]
  group rounded-2xl shadow-md border border-gray-100
  flex flex-col justify-between
  transform transition-all duration-300 ease-in-out
  ${isActive
                        ? "scale-105 bg-gradient-to-r from-[#3C0B45] to-[#0F2358] text-white"
                        : "hover:scale-105 bg-white text-black hover:bg-gradient-to-r hover:from-[#3C0B45] hover:to-[#0F2358] hover:text-white"
                      }
`}


                    onClick={() => clickCard(index)}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    {/* Header */}
                    <div
                      className={`${plan.color} text-white text-center rounded-t-2xl py-8 sm:py-4 font-bold text-2xl sm:text-[20px] md:text-[30px] pointer-events-none`}
                    >
                      {plan.name}
                    </div>

                    {/* Content */}
                    <div className={`p-8 flex flex-col flex-grow bg-gradient-to-r rounded-b-2xl text-[12px] md:text-[20px]`}>
                      <h2
                        className={` font-bold text-gray-900 group-hover:text-white ${isActive ? "text-white" : "text-black"
                          }`}
                      >
                        {plan.price}{" "}
                        <span
                          className={` font-semibold text-gray-600 group-hover:text-white ${isActive ? "text-white" : "text-black"
                            }`}
                        >
                          {plan.period}
                        </span>
                        <span className="text-[12px] sm:text-[8px] font-medium">{" "}(excl. vat)</span>
                      </h2>

                      <p
                        className={`text-gray-600 mt-2 mb-4 group-hover:text-white ${isActive ? "text-white" : "text-black"
                          }`}
                      >
                        {plan.desc}
                      </p>

                      <hr className="border-gray-300 mb-4 group-hover:border-white" />

                      <p
                        className={`font-semibold text-gray-900 mb-3 group-hover:text-white ${isActive ? "text-white" : "text-black"
                          }`}
                      >
                        Included:
                        {/* <BsArrowUpRightCircleFill size={24} color="#f11616ff" /> */}
                      </p>

                      <ul
                        className={`space-y-2 text-gray-700 group-hover:text-white ${isActive ? "text-white" : "text-black"
                          }`}
                      >
                        {plan.features.map((feature, i) => (
                          <li key={i} className="flex items-center gap-2 lowercase">
                            <span className="flex items-start gap-2 text-inherit">
                              {/* IMPORTANT: plain wrapper so no text color or hover color interferes with PNG */}
                              <span className="rounded-full flex items-center justify-start w-7 h-6 md:h-10 ">
                                {/* <img
                                src={isActive || isHover ?rightmark  : rightmarkdefault}
                                alt="checkmark"
                                className="w-full h-full transition duration-200"
                              /> */}
                                {isActive || isHover ?
                                  // <IoCheckmarkCircle
                                  //   className="w-6 h-6"
                                  //   style={{
                                  //     color: "#FFFFFF",                    // ✔ right mark color (white)
                                  //     fill: "rgba(255,255,255,0.25)"
                                  //   }}
                                  // ></IoCheckmarkCircle>
                                  <div className="w-2 h-2 sm:w-5 sm:h-5 md:w-7 md:h-7 lg:w-8 lg:h-8">
                                    <CheckmarkIconWithBgBlack
                                      circleColor="rgba(255,255,255,0.25)"
                                      tickColor="#FFFFFF"
                                    />
                                  </div>

                                  :
                                  <div className="w-2 h-2 sm:w-5 sm:h-5 md:w-7 md:h-7 lg:w-8 lg:h-8">
                                    <CheckmarkIconWithBgWhite />
                                  </div>
                                  //  <IoCheckmarkCircle
                                  //   className={`w-[30px] h-[30px] transition duration-200`}
                                  //   fill="rgba(110, 63, 198, 0.25)" stroke="red"
                                  // />
                                }
                              </span>
                              <span>{feature}</span>
                            </span>
                          </li>
                        ))}
                      </ul>

                      <div className="mt-auto pt-6 flex flex-col items-center gap-3">
                        {
                          index === 0 &&
                          <div className="flex flex-wrap justify-center items-center gap-3">
                            <span><GlowButton btnValue="free trial" btn1="2" onMouseOver={() => setIsMouseOverForBase(true)} onMouseOut={() => setIsMouseOverForBase(false)} isMouseOver={isMouseOverForBase} onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] lg:px-[40px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                          </div>
                        }

                        {
                          index === 1 &&
                          <div className="flex flex-wrap justify-center items-center gap-3">
                            <span><GlowButton btnValue="free trial" btn1="2" onMouseOver={() => setIsMouseOverForPremium(true)} onMouseOut={() => setIsMouseOverForPremium(false)} isMouseOver={isMouseOverForPremium} onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] lg:px-[40px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                          </div>
                        }

                        {
                          index === 2 &&
                          <div className="flex flex-wrap justify-center items-center gap-3">
                            <span><GlowButton btnValue="free trial" btn1="2" onMouseOver={() => setIsMouseOverForPremiumPlus(true)} onMouseOut={() => setIsMouseOverForPremiumPlus(false)} isMouseOver={isMouseOverForPremiumPlus} onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] lg:px-[40px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                          </div>
                        }

                        {
                          index === 3 &&
                          <div className="flex flex-wrap justify-center items-center gap-3">
                            <span><GlowButton btnValue="free trial" btn1="2" onMouseOver={() => setIsMouseOverForUltimate(true)} onMouseOut={() => setIsMouseOverForUltimate(false)} isMouseOver={isMouseOverForUltimate} onClick={() => window.location.href = "/business/get-started"}></GlowButton></span>
                            <button
                              onClick={() => window.location.href = "/business/demo"}
                              className="inline-flex items-center justify-center whitespace-nowrap border border-[#6E3FC6] bg-[#e9d9ff] hover:bg-[#d8bfff] text-black text-sm sm:text-base font-medium px-[18px] sm:px-[25px] lg:px-[40px] rounded-full transition-all duration-300 cursor-pointer"
                            >
                              how it works
                            </button>
                          </div>
                        }

                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
        </section>

        <div className="flex flex-col items-center justify-center bg-white px-4 py-10 xl-2xl:mt-[-2rem]">
          {/* Compare Button */}
          <button
            className="mt-8 px-[40px] py-2 border-2 border-solid border-[#6E3FC6] rounded-[15px] hover:text-[21px] transition font-medium lowercase text-[#6E3FC6] text-[20px] hover:scale-100"
            onClick={() => setCompareBtn(!compare)}
          >
            {compare ? "Hide Comparison" : "Compare"}
          </button>
        </div>

        {/* Show comparison table when compare is true */}
        {compare && <PricingNavContentPageCompare />}

        {/* Show individual package details when compare is false */}
        {!compare && <PricingNavContentPage2 btnContentValue={btnValue} />}
      </div>
    </>
  );
}

const CheckmarkIconWithBgBlack = () => (
  <svg viewBox="0 0 512 512">
    <circle cx="256" cy="256" r="256" fill="rgba(255,255,255,0.25)" />
    <polyline
      points="160,256 230,320 352,192"
      fill="none"
      stroke="white"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckmarkIconWithBgWhite = () => (
  <svg viewBox="0 0 512 512">
    <circle cx="256" cy="256" r="256" fill="rgba(110, 63, 198, 0.25)" />
    <polyline
      points="160,256 230,320 352,192"
      fill="none"
      stroke="#6E3FC6"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export default PricingNavContentPage1;
